// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__P60_P","icon":"SortAdornment_icon__inGYD","up":"SortAdornment_up__3if8v","down":"SortAdornment_down__1NYIL","active":"SortAdornment_active__2zU2S"};